import antDesignFont from 'react-native-vector-icons/Fonts/AntDesign.ttf';
import entypoFont from 'react-native-vector-icons/Fonts/Entypo.ttf';
import evilIconsFont from 'react-native-vector-icons/Fonts/EvilIcons.ttf';
import featherFont from 'react-native-vector-icons/Fonts/Feather.ttf';
import fontAwesomeFont from 'react-native-vector-icons/Fonts/FontAwesome.ttf';
import fontAwesome5BrandsFont from 'react-native-vector-icons/Fonts/FontAwesome5_Brands.ttf';
import fontAwesome5RegularFont from 'react-native-vector-icons/Fonts/FontAwesome5_Regular.ttf';
import fontAwesome5SolidFont from 'react-native-vector-icons/Fonts/FontAwesome5_Solid.ttf';
import fontistoFont from 'react-native-vector-icons/Fonts/Fontisto.ttf';
import foundationFont from 'react-native-vector-icons/Fonts/Foundation.ttf';
import ioniconsFont from 'react-native-vector-icons/Fonts/Ionicons.ttf';
import materialCommunityIconsFont from 'react-native-vector-icons/Fonts/MaterialCommunityIcons.ttf';
import materialIconsFont from 'react-native-vector-icons/Fonts/MaterialIcons.ttf';
import octiconsFont from 'react-native-vector-icons/Fonts/Octicons.ttf';

const iconFonts = [
  ['AntDesign', antDesignFont],
  ['Entypo', entypoFont],
  ['EvilIcons', evilIconsFont],
  ['Feather', featherFont],
  ['FontAwesome', fontAwesomeFont],
  ['FontAwesome5_Brands', fontAwesome5BrandsFont],
  ['FontAwesome5_Regular', fontAwesome5RegularFont],
  ['FontAwesome5_Solid', fontAwesome5SolidFont],
  ['Fontisto', fontistoFont],
  ['Foundation', foundationFont],
  ['Ionicons', ioniconsFont],
  ['MaterialCommunityIcons', materialCommunityIconsFont],
  ['MaterialIcons', materialIconsFont],
  ['Octicons', octiconsFont]
];

const fontFaceCss = iconFonts
  .map(
    ([fontFamily, fontUrl]) => `@font-face {
  font-family: '${fontFamily}';
  src: url('${fontUrl}') format('truetype');
  font-weight: normal;
  font-style: normal;
}`
  )
  .join('\n');

if (typeof document !== 'undefined' && !document.getElementById('rnvi-fonts')) {
  const style = document.createElement('style');
  style.id = 'rnvi-fonts';
  style.type = 'text/css';
  style.appendChild(document.createTextNode(fontFaceCss));
  document.head.appendChild(style);
}
